import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { addSkillsRole, roles, skills } from "../../../../store/roles_skills";
import { useGetAllSkillsQuery } from "../../../../store/skillsApi";

interface Props {
  isShown: boolean;
  role: roles;
  toggle: any;
}

const AddSkills = ({ isShown, role, toggle }: Props) => {
  const dispatch = useAppDispatch();
  const { data: allSkillsData } = useGetAllSkillsQuery();
  const { status } = useAppSelector((store) => store.roles_skills);
  const [selec, setSelec] = useState<skills[]>([]);
  const [select, setSelect] = useState(role.skills);
  let selectable: skills[] = [];

  const handleSelects = (value: string) => {
    let newSelec = selec.filter((selec) => selec.slug !== value);
    let newSelect = select.map((selec) => {
      return selec;
    });
    newSelect.push(...selec.filter((selec) => selec.slug === value));

    setSelec(newSelec);
    setSelect(newSelect);
  };

  const handleDeSelects = (value: string) => {
    let newSelect = select.filter((selec) => selec.slug !== value);
    let newSelec = selec.map((selec) => {
      return selec;
    });

    newSelec.push(...select.filter((selec) => selec.slug === value));

    setSelec(newSelec);
    setSelect(newSelect);
  };

  const handleSubmit = () => {
    let send = select.map((selec) => {
      return selec.id_encrypted;
    });
    // console.log(send);
    if (isShown) {
      dispatch(addSkillsRole({ id_role: role.id_encrypted, id_skill: send }));
    }
  };

  useEffect(() => {
    if (isShown && allSkillsData?.data) {
      selectable = allSkillsData.data.filter((skill) => {
        return !role.skills.find((skills) => {
          return skill.slug === skills.slug;
        });
      });
      setSelec(selectable);
      setSelect(role.skills);
    }
  }, [isShown, allSkillsData]);

  useEffect(() => {
    if (isShown && status === "addSkillsRole_success") {
      toggle();
    }
  }, [isShown, status]);

  return (
    <>
      <div className="c-select-list">
        <span style={{ marginBottom: "10px" }}>Skills List</span>
        <div className="c-select-list__select-container">
          <div className="c-select-list__selectable">
            {/* <input
              type="text"
              autoComplete="off"
              placeholder="Search a skill"
              className="c-select-list__input"
            /> */}
            <ul className="c-select-list__list" id="list-selectable">
              {isShown &&
                selec &&
                selec.map((select) => (
                  <li
                    className="c-list-options__item"
                    onClick={() => handleSelects(select.slug)}
                  >
                    <span>{select.slug}</span>
                  </li>
                ))}
            </ul>
          </div>
          <div className="c-select-list__selection">
            {/* <input
              type="text"
              autoComplete="off"
              placeholder="Search a skill"
              className="c-select-list__input"
            /> */}
            <ul className="c-select-list__list">
              {select &&
                select.map((skill) => (
                  <li
                    className="c-list-options__item"
                    key={skill.id}
                    id={skill.id_encrypted + role.id_encrypted + skill.id}
                    onClick={() => handleDeSelects(skill.slug)}
                  >
                    <span>{skill.slug} </span>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div className="c-select-list__footer" style={{ marginTop: "20px" }}>
          <button
            type="submit"
            className="c-select-list__button-submit"
            onClick={handleSubmit}
          >
            Save Changes
          </button>
        </div>
      </div>
    </>
  );
};
export default AddSkills;
